import { Roster } from '@/types/classroom';
import { actionCreatorFactory } from 'typescript-fsa';

const action = actionCreatorFactory('ROSTER');
export const setRoster = action<Roster>('SET_ROSTER');
